import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GoogleMapService {
  private distanceMatrixApi = 'https://maps.googleapis.com/maps/api/distancematrix/json';
  private readonly apiKey = 'AIzaSyCIb0oD5OW0QMkDK9DQes46pRZcAHnua6k';

  constructor(
    private http: HttpClient
  ) { }

  public calculateDistance(origin: string, destinations: string[]): Observable<any> {
    const destinationsString = destinations.map(destination => encodeURIComponent(destination)).join('|');
    const originsEncoded = encodeURIComponent(origin);
    return this.http.get(environment.wsUrl + 'google-maps/distance-matrix', {
      params: { originAddress: originsEncoded, destinations: destinationsString, apiKey: this.apiKey }
    });
  }

  public reverseGeocode(latLng: google.maps.LatLngLiteral): Observable<any> {
    const apiUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latLng.lat},${latLng.lng}&key=${this.apiKey}`;
    return this.http.get(apiUrl);
  }

  public findAddress(currentAddress: string): Observable<any> {
    const formattedAddress = encodeURIComponent(currentAddress);
    const apiUrl = `https://maps.googleapis.com/maps/api/geocode/json?address=${formattedAddress}&key=${this.apiKey}`;
    return this.http.get(apiUrl);
  }
}
